module.exports = __webpack_public_path__ + "static/img/did.037e477a.png";